import * as React from 'react'
import { useEffect, useState, Suspense } from 'react'
import '../css/clusterCarousel.css'

const Clusters = React.lazy(() => import('../svg/clusters'))

export const ClusterCarousel = () => {
  const [selectedOption, setSelectedOption] = useState(1)

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedOption(selectedOption === 3 ? 1 : selectedOption + 1)
    }, 4000)
    return () => clearInterval(interval)
  }, [selectedOption])

  return (
    <div className="cluster-carousel">
      <Suspense fallback={<div />}>
        <Clusters clusterNumber={selectedOption} />
      </Suspense>
      <div className="cluster-carousel__options">
        <div onClick={() => setSelectedOption(1)} className={`cluster-carousel__option cluster-carousel__option-1 ${selectedOption !== 1 ? 'cluster-carousel__option--disabled' : ''}`}>
          <div />
          <span>Cluster 1</span>
        </div>
        <div onClick={() => setSelectedOption(2)} className={`cluster-carousel__option cluster-carousel__option-2 ${selectedOption !== 2 ? 'cluster-carousel__option--disabled' : ''}`}>
          <div />
          <span>Cluster 2</span>
        </div>
        <div onClick={() => setSelectedOption(3)} className={`cluster-carousel__option cluster-carousel__option-3 ${selectedOption !== 3 ? 'cluster-carousel__option--disabled' : ''}`}>
          <div />
          <span>Cluster 3</span>
        </div>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/clusterCarousel.tsx